import cookie from '../cookie'

const isError = error => {
  try {
    if (error instanceof Error) return true
    if (error.constructor.toString().match(/Error/)) return true // cypress errors
    return false
  } catch (_error) {
    return false
  }
}

const triggerPageActionEvent = eventProps => {
  if (
    typeof window.newrelic !== 'undefined' &&
    typeof window.newrelic.addPageAction === 'function'
  ) {
    window.newrelic.addPageAction('sso-ui', eventProps)
  }
}

export const newRelicTriggerSuccessEvent = page => triggerPageActionEvent({ type: 'success', page })

export const newRelicTriggerErrorEvent = (page, originalError) => {
  const error = isError(originalError) ? originalError.message : originalError
  triggerPageActionEvent({ type: 'error', page, error })
}

export const setupNewRelic = () => {
  if (
    typeof window.newrelic !== 'undefined' &&
    typeof window.newrelic.setCustomAttribute === 'function'
  ) {
    window.newrelic.setCustomAttribute('sessionId', cookie.getCookie('jl_session_id'))
  }
}

const newRelicTriggerTimeEvent = args => {
  const userAgent = window.navigator.userAgent
  const fullCode = new URLSearchParams(window.location.search).get('code') || ''
  const code = fullCode.substr(-3)
  triggerPageActionEvent({ ...args, userAgent, code, group: 'perf' })
}

export const newRelicTimeFunction = async (functionName, fn) => {
  let start = performance.now()
  try {
    const result = await fn()
    const end = performance.now()
    newRelicTriggerTimeEvent({
      functionName,
      type: 'success',
      time: Math.round(end - start),
    })
    return result
  } catch (error) {
    const end = performance.now()
    newRelicTriggerTimeEvent({
      functionName,
      type: 'error',
      time: Math.round(end - start),
      error: error.message,
    })
    throw error
  }
}
